import { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { CallTabData } from "../../../../../Data/Messenger/Messenger";
import AllCall from "./AllCall";

const CallTab = () => {
  const [callSubTab, setCallSubTab] = useState("all");

  return (
    <div className="template-tab tab-icon">
      <Nav tabs>
        {CallTabData.map((item, index) => (
          <NavItem key={index}>
            <NavLink className={callSubTab === item.type ? "active" : ""} onClick={() => setCallSubTab(item.type)}>
              {item.title ? item.title : item.icon}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <TabContent activeTab={callSubTab}>
        <TabPane tabId="all">
          <AllCall startValue={0} endValue={6} />
        </TabPane>
        <TabPane tabId="incoming">
          <AllCall startValue={6} endValue={11} />
        </TabPane>
        <TabPane tabId="outgoing">
          <AllCall startValue={11} endValue={16} />
        </TabPane>
        <TabPane tabId="cancel">
          <AllCall startValue={16} endValue={22} />
        </TabPane>
      </TabContent>
    </div>
  );
};

export default CallTab;
